import { css } from "styled-components";
const paddingButtonStyle = (small, theme)=>css`
  padding: ${small ? theme.sizes.s2 : theme.sizes.s3} ${theme.sizes.s4};
`;
export default paddingButtonStyle;
